// TODO: Review, probably enums are not required in the application at all.
export enum Actions {
  Delete = -1,
  Create = 101,
  Assign = 102,
  Submit = 201,
  RequestRedirect = 202,
  RequestRecycle = 301,
  RequestOpenAndScan = 302,
  RequestForward = 303,
  RequestPickUp = 304,
  RequestShred = 305,
  // RequestDelivery = 306,
  FinishRecycle = 401,
  FinishOpenAndScan = 402,
  FinishForward = 403,
  FinishPickUp = 404,
  FinishShred = 405,
  FinishPickUpWithSignature = 406,
  FinishPickUpWithQrCode = 407,
  // FinishDelivery = 408,
  // FinishDeliveryWithSignature = 409,
  // FinishDeliveryWithQrCode = 410,
  RemindAction = 501,
  EscalateAction = 502,
  RemindReview = 503,
  EscalateReview = 504,
  ViewDoc = 601,
  DownloadDoc = 602,
  Archive = 901,
}

// TODO: Review, probably enums are not required in the application at all.
export enum LifecycleStage {
  Imaged = Actions.Create,
  Assigned = Actions.Assign,
  Sent = Actions.Submit,
  RecycleRequested = Actions.RequestRecycle,
  OpenAndScanRequested = Actions.RequestOpenAndScan,
  ForwardRequested = Actions.RequestForward,
  PickupRequested = Actions.RequestPickUp,
  ShredRequested = Actions.RequestShred,
  RecycleCompleted = Actions.FinishRecycle,
  OpenAndScanCompleted = Actions.FinishOpenAndScan,
  ForwardCompleted = Actions.FinishForward,
  PickupCompleted = Actions.FinishPickUp,
  ShredCompleted = Actions.FinishShred,
}

// TODO: Review, probably enums are not required in the application at all.
export enum LifecycleStageGroups {
  Delete = -1,
  Creation = 100,
  Submitting = 200,
  ActionRequested = 300,
  ActionFinished = 400,
  Notification = 500,
  Document = 600,
  Archive = 900,
}
